module.exports = __webpack_public_path__ + "img/logo839.8d66cfb2.png";